"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Checkbox_1 = __importDefault(require("@/Components/common/Checkbox"));
var AppTemplateEditor_module_css_1 = __importDefault(require("./AppTemplateEditor.module.css"));
var AppTemplateInfoModal = function (_a) {
    var isShown = _a.isShown, toggle = _a.toggle, appTemplateData = _a.appTemplateData, onSave = _a.onSave;
    var _b = (0, react_1.useState)(appTemplateData.name || ""), templateName = _b[0], setTemplateName = _b[1];
    var _c = (0, react_1.useState)(appTemplateData.public), isPublic = _c[0], setIsPublic = _c[1];
    var _d = (0, react_1.useState)(appTemplateData.visible), isVisible = _d[0], setIsVisible = _d[1];
    (0, react_1.useEffect)(function () {
        if (isShown) {
            setTemplateName(appTemplateData.name || "");
            setIsPublic(appTemplateData.public);
            setIsVisible(appTemplateData.visible);
        }
    }, [isShown, appTemplateData.name, appTemplateData.public, appTemplateData.visible]);
    var templateInfoModalHeader = (react_1.default.createElement("div", { className: "ns-font-family-bold", style: { fontSize: "20px", color: "var(--info-color)" } },
        react_1.default.createElement("div", { style: { color: "var(--info-color)" } }, "Template Info")));
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onSave(templateName, isPublic, isVisible)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: isShown, onClose: toggle, centered: true, header: templateInfoModalHeader, body: react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["template-info-main-container"] },
            react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["template-info-container"] },
                react_1.default.createElement("label", { className: AppTemplateEditor_module_css_1.default["template-info-label"], style: { display: "block", marginBottom: "5px" } }, "Name:"),
                react_1.default.createElement(q_play_components_1.Input, { type: "text", id: "templateName", value: templateName, onChange: function (e) { return setTemplateName(e.target.value); }, style: {
                        fontSize: "14px",
                        padding: "8px",
                        boxSizing: "border-box",
                    } }),
                react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["template-info-checkbox"] },
                    react_1.default.createElement("label", { className: AppTemplateEditor_module_css_1.default["template-info-label"] }, "Visible:"),
                    react_1.default.createElement(Checkbox_1.default, { checked: isVisible, onChange: function () { return setIsVisible(!isVisible); } })),
                react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["template-info-checkbox-second"] },
                    react_1.default.createElement("label", { className: AppTemplateEditor_module_css_1.default["template-info-label"] }, "Public:"),
                    react_1.default.createElement(Checkbox_1.default, { checked: isPublic, onChange: function () { return setIsPublic(!isPublic); } })),
                react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["save-button-wrapper"] },
                    react_1.default.createElement(q_play_components_1.Button, { text: "Save", onClick: handleSave })))) }));
};
exports.default = AppTemplateInfoModal;
